import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TosAdapter {
  private http = inject(HttpClient);

  getTosAccepted(): Observable<{ accepted: boolean; latestChange: string }> {
    return this.http.get<{ accepted: boolean; latestChange: string }>(
      `${environment.apiBaseUrl}/company/latest-tos-accepted`
    );
  }

  acceptsTos(): Observable<any> {
    return this.http.patch<any>(`${environment.apiBaseUrl}/company/accept-tos`, {});
  }

  declineTos(): Observable<any> {
    return this.http.patch(`${environment.apiBaseUrl}/company/decline-tos`, {});
  }
}
